<p>sim-list works!</p>
<app-table-standard-layout [dataSource$]="simList$" [title]="'Sim cards'" [rowActionButtons]="rowActionButtons"
  [columnSettings]="columnSettings"></app-table-standard-layout>

  <button mat-raised-button color="primary" (click)="openAddSimDialog()">
    <mat-icon>add</mat-icon>
    Add Sim
    </button>